import { useState } from 'react'
import Layout from '../../components/Layout'
import userService from '../../services/userService'
import Toast from '../../utils/toast'
import '../reports/style.css'

/**
 * ChangePassword Component
 * 
 * Page for changing user password.
 */
function ChangePassword() {
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [transactionPassword, setTransactionPassword] = useState('')
  const [loading, setLoading] = useState(false)

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault()

    // Validation
    if (!newPassword || !confirmPassword || !transactionPassword) {
      Toast.fire({
        icon: 'error',
        title: 'Please fill in all fields'
      });
      return
    }

    if (newPassword !== confirmPassword) {
      Toast.fire({
        icon: 'error',
        title: 'New Password and Confirm Password do not match'
      });
      return
    }

    setLoading(true)
    try {
      const payload = {
        newPassword: newPassword,
        transactionPassword: transactionPassword
      }

      const response = await userService.updateLoggedInStaffPassword(payload)

      if (response.success) {
        Toast.fire({
          icon: 'success',
          title: 'Password changed successfully'
        });
        // Reset form
        setNewPassword('')
        setConfirmPassword('')
        setTransactionPassword('')
      } else {
        Toast.fire({
          icon: 'error',
          title: 'Failed to change password: ' + (response.message || response.error || 'Unknown error')
        });
      }
    } catch (error) {
      console.error('Error changing password:', error)
      Toast.fire({
        icon: 'error',
        title: 'Failed to change password: ' + (error.response?.data?.message || error.response?.data?.error || error.message)
      });
    } finally {
      setLoading(false)
    }
  }

  return (
    <Layout title="Change Password - Diamond Admin">
      <div className="listing-grid">
        <div className="account-list-statement">
          {/* Page Title */}
          <div className="row">
            <div className="col-12">
              <div className="page-title-box d-flex align-items-center justify-content-between">
                <h4 className="mb-0 font-size-18">
                  Change Password
                </h4>
              </div>
            </div>
          </div>

          {/* Password Form */}
          <div className="row">
            <div className="col-12">
              <div className="">
                <div className="">
                  <form method="post" className="ajaxFormSubmit" onSubmit={handleSubmit}>
                    <div className="row row5">
                      <div className="col-md-6">
                        <label>New Password:</label>
                        <input
                          type="password"
                          className="form-control w-full max-w-[400px]"
                          //   placeholder="Enter new password"
                          value={newPassword}
                          onChange={(e) => setNewPassword(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    <div className="row row5 mt-3">
                      <div className="col-md-6">
                        <label>Confirm Password:</label>
                        <input
                          type="password"
                          className="form-control w-full max-w-[400px]"
                          //   placeholder="Confirm new password"
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    <div className="row row5 mt-3">
                      <div className="col-md-6">
                        <label>Transaction Password:</label>
                        <input
                          type="password"
                          className="form-control w-full max-w-[400px]"
                          //   placeholder="Enter transaction password"
                          value={transactionPassword}
                          onChange={(e) => setTransactionPassword(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    <div className="row row5 mt-3">
                      <div className="col-md-6">
                        <button
                          type="submit"
                          className="btn btn-primary"
                          disabled={loading}
                        >
                          {loading ? 'Loading...' : 'Load'}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default ChangePassword

